"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRouterConfig = void 0;
var react_1 = __importDefault(require("react"));
var bankuai_1 = require("../page/bankuai");
var gold_1 = require("../page/gold");
var home_1 = require("../page/home");
var hsgt_1 = require("../page/hsgt");
var hsj_1 = require("../page/hsj");
var hszs_1 = require("../page/hszs");
var qqzq_1 = require("../page/qqzq");
var quote_grid_1 = require("../page/quote_grid");
var quote_grid_l2tab_1 = require("../page/quote_grid_l2tab");
var mgsc_1 = require("../page/mgsc");
var yg_1 = require("../page/yg");
var qqzs_1 = require("../page/qqzs");
var qqzslist_1 = require("../page/qqzslist");
var ggsc_1 = require("../page/ggsc");
var hk_1 = require("../page/hk");
var gdr_1 = require("../page/gdr");
var jjsc_1 = require("../page/jjsc");
var zqsc_1 = require("../page/zqsc");
var quote_full_1 = require("../page/quote_full");
var whsc_1 = require("../page/whsc");
var whpj_1 = require("../page/whpj");
var hsjzs_1 = require("../page/hsjzs");
var boardlist_1 = require("../page/boardlist");
var qihuo_grid_1 = require("../page/qihuo_grid");
var future_1 = require("../page/future");
var option_sh_sz_1 = require("../page/option_sh_sz");
var qqsc_1 = require("../page/qqsc");
var futures_1 = require("../page/futures");
var option_txbj_1 = require("../page/option_txbj");
var option_qihuo_1 = require("../page/option_qihuo");
var hsgt_stock_1 = require("../page/hsgt_stock");
var kcb_1 = require("../page/kcb");
/**
 * 前端页面路由配置
 */
exports.PageRouterConfig = [
    {
        page: react_1.default.createElement(home_1.PageHome, null),
        path: ['', '/', '/center', '/index.html']
    },
    {
        page: react_1.default.createElement(hsj_1.PageHSJ, null),
        path: [
            '/gridlist.html#hs_a_board',
            '/gridlist.html#sh_a_board',
            '/gridlist.html#sh_a_board_zcz',
            '/gridlist.html#sh_a_board_hzz',
            '/gridlist.html#sz_a_board',
            '/gridlist.html#sz_a_board_zcz',
            '/gridlist.html#sz_a_board_hzz',
            '/gridlist.html#bj_a_board',
            '/gridlist.html#newshares',
            '/gridlist.html#gem_board',
            '/gridlist.html#gem_board_zcz',
            '/gridlist.html#gem_board_hzz',
            '/gridlist.html#kcb_board',
            '/gridlist.html#sh_hk_board',
            '/gridlist.html#sz_hk_board',
            '/gridlist.html#b_board',
            '/gridlist.html#ab_comparison',
            '/gridlist.html#ab_comparison_sh',
            '/gridlist.html#ab_comparison_sz',
            '/gridlist.html#st_board',
            '/gridlist.html#st_board_sh',
            '/gridlist.html#st_board_sz',
            '/gridlist.html#st_board_bj',
            '/gridlist.html#st_board_kcb',
            '/gridlist.html#st_board_cyb',
            '/gridlist.html#staq_net_board',
            '/gridlist.html#delisting_board',
            '/gridlist.html#delisting_board_sh',
            '/gridlist.html#delisting_board_sz',
            '/gridlist.html#delisting_board_bj'
        ]
    },
    {
        page: react_1.default.createElement(hsjzs_1.PageHSJZS, null),
        path: [
            '/gridlist.html#index_sh',
            '/gridlist.html#index_sz',
            '/gridlist.html#index_components',
            '/gridlist.html#index_zzzs',
        ]
    },
    {
        page: react_1.default.createElement(hsgt_1.PageHSGT, null),
        path: ['/hsgt.html']
    },
    {
        page: react_1.default.createElement(quote_grid_1.PageQuoteGrid, null),
        path: [
            // 沪深港通etf
            '/gridlist.html#sh_hk_board_fund',
            '/gridlist.html#sz_hk_board_fund',
            '/gridlist.html#hk_sh_board_fund',
            '/gridlist.html#hk_sz_board_fund',
            '/gridlist.html#ggt_etf_board',
            // 美股市场
            '/gridlist.html#us_stocks',
            '/gridlist.html#us_wellknown',
            '/gridlist.html#us_chinese',
            '/gridlist.html#us_chinese_internet',
            '/gridlist.html#us_index',
            '/gridlist.html#us_pinksheet',
            '/gridlist.html#us_technology',
            '/gridlist.html#us_financial',
            '/gridlist.html#us_medicine_food',
            '/gridlist.html#us_media',
            '/gridlist.html#us_automotive_energy',
            '/gridlist.html#us_manufacture_retail',
            // 英股
            '/gridlist.html#stocks_all',
            '/gridlist.html#stocks_mt_156_7',
            '/gridlist.html#stocks_b_mk0794',
            '/gridlist.html#stocks_mt_155_3',
            '/gridlist.html#stocks_mt_341',
            // 基金
            '/gridlist.html#fund_close_end',
            '/gridlist.html#fund_etf',
            '/gridlist.html#fund_lof',
            // 债券市场
            '/gridlist.html#bond_index',
            '/gridlist.html#bond_sh',
            '/gridlist.html#bond_national_sh',
            '/gridlist.html#bond_enterprise_sh',
            '/gridlist.html#bond_convertible_sh',
            '/gridlist.html#bond_sz',
            '/gridlist.html#bond_national_sz',
            '/gridlist.html#bond_enterprise_sz',
            '/gridlist.html#bond_bj',
            '/gridlist.html#bond_enterprise_bj',
            '/gridlist.html#bond_convertible_sz',
            '/gridlist.html#bond_sh_buyback',
            '/gridlist.html#bond_sz_buyback',
            // 外汇市场
            '/gridlist.html#forex_all',
            '/gridlist.html#forex_basic',
            '/gridlist.html#forex_cross',
            '/gridlist.html#forex_cny',
            '/gridlist.html#forex_cnyc',
            // '/gridlist.html#forex_cnyi',
            '/gridlist.html#forex_cnh',
            // REITS
            '/gridlist.html#fund_reits_all',
            '/gridlist.html#fund_reits_sh',
            '/gridlist.html#fund_reits_sz',
            // 黄金市场
            '/gridlist.html#gold_sh_spotgoods',
            '/gridlist.html#gold_sh_futures',
            '/gridlist.html#nobalmetal_spotgoods',
            '/gridlist.html#nobalmetal_futures',
        ]
    },
    {
        page: react_1.default.createElement(quote_grid_l2tab_1.PageQuoteGrid2Tab, null),
        path: [
            '/gridlist.html#neeq_stocks',
            '/gridlist.html#neeq_innovate',
            '/gridlist.html#neeq_basic',
            '/gridlist.html#neeq_marketmaking',
            '/gridlist.html#neeq_bidding'
        ]
    },
    {
        page: react_1.default.createElement(qqzq_1.PageQQZQ, null),
        path: ['/qqzq.html']
    },
    {
        page: react_1.default.createElement(gold_1.PageGold, null),
        path: ['/hjsc.html']
    },
    {
        page: react_1.default.createElement(hszs_1.PageHSZS, null),
        path: ['/hszs.html']
    },
    {
        page: react_1.default.createElement(bankuai_1.PageBanKuai, null),
        path: ['/hsbk.html']
    },
    {
        page: react_1.default.createElement(boardlist_1.PageBoardlist, null),
        path: [
            '/gridlist.html#concept_board',
            '/gridlist.html#region_board',
            '/gridlist.html#industry_board',
            '/gridlist.html#industry_board_1',
            '/gridlist.html#industry_board_2',
            '/gridlist.html#industry_board_3',
            '/gridlist.html#boards2-90.bk{d}' // 板块-子板块
        ]
    },
    {
        page: react_1.default.createElement(mgsc_1.PageMGSC, null),
        path: ['/mgsc.html']
    },
    {
        page: react_1.default.createElement(yg_1.PageYG, null),
        path: ['/yg.html']
    },
    {
        page: react_1.default.createElement(gdr_1.PageGDR, null),
        path: ['/gridlist.html#stocks_mt_252_1']
    },
    {
        page: react_1.default.createElement(qqzs_1.PageQQHOME, null),
        path: ['/qqzs.html']
    },
    {
        page: react_1.default.createElement(qqzslist_1.PageQQZS, null),
        path: [
            '/gridlist.html#global_asia',
            '/gridlist.html#global_euro',
            '/gridlist.html#global_america',
            '/gridlist.html#global_australia',
            '/gridlist.html#global_qtzs'
        ]
    },
    {
        page: react_1.default.createElement(quote_grid_1.PageQuoteGrid, null),
        path: [
            '/gridlist.html#ah_comparison',
            '/gridlist.html#hkah_comparison',
            '/gridlist.html#hk_stocks',
            '/gridlist.html#hk_mainboard',
            '/gridlist.html#hk_gem',
            '/gridlist.html#hk_wellknown',
            '/gridlist.html#hk_bluechips',
            '/gridlist.html#hk_redchips',
            '/gridlist.html#hk_redchips_components',
            '/gridlist.html#hk_stateowned',
            '/gridlist.html#hk_stateowned_components',
            '/gridlist.html#hk_components',
            '/gridlist.html#hsi_large_components',
            '/gridlist.html#hsi_medium_components',
            '/gridlist.html#hk_index',
            '/gridlist.html#hk_warrants',
            '/gridlist.html#hk_cbbcs',
            '/gridlist.html#hk_adr',
            '/gridlist.html#hk_rmb',
            // '/gjs.html#futures_hkex',   // futures_hkex期货-港交所有延时市场处理
            // '/gridlist.html#futures_hkex',   // futures_hkex期货-港交所有延时市场处理
            // // 期货市场-港交所
            // '/gridlist.html#hk_index_futures',
            // '/gridlist.html#hk_stock_futures',
            // '/gridlist.html#hcf_cus',
            // '/gridlist.html#hmfs_lrp',
        ]
    },
    {
        page: react_1.default.createElement(kcb_1.PageKCB, null),
        path: [
            '/kcb.html'
        ]
    },
    {
        page: react_1.default.createElement(hk_1.PageDelayHK, null),
        path: [
            '/gridlist.html#futures_hkex',
            // 期货市场-港交所
            '/gridlist.html#hk_index_futures',
            '/gridlist.html#hk_stock_futures',
            '/gridlist.html#hcf_cus',
            '/gridlist.html#hmfs_lrp',
        ]
    },
    {
        page: react_1.default.createElement(hsgt_stock_1.PageHSGTStock, null),
        path: [
            '/gridlist.html#hk_sh_stocks',
            '/gridlist.html#hk_sz_stocks', // 沪深港通-港股通-深港  有延时市场
        ]
    },
    {
        page: react_1.default.createElement(ggsc_1.PageGGSC, null),
        path: ['/ggsc.html']
    },
    {
        page: react_1.default.createElement(jjsc_1.PageJJSC, null),
        path: ['/jjsc.html', '/jjsc']
    },
    {
        page: react_1.default.createElement(zqsc_1.PageZQSC, null),
        path: ['/zqsc.html']
    },
    {
        page: react_1.default.createElement(quote_full_1.PageQuoteFull, null),
        path: [
            '/fullscreenlist.html#convertible_comparison'
        ]
    },
    {
        page: react_1.default.createElement(whsc_1.PageWHSC, null),
        path: [
            '/whsc.html'
        ]
    },
    {
        page: react_1.default.createElement(whpj_1.PageWHPJ, null),
        path: [
            '/gridlist.html#forex_exchange_icbc',
            '/gridlist.html#forex_exchange_abc',
            '/gridlist.html#forex_exchange_boc',
            '/gridlist.html#forex_exchange_ccb',
            '/gridlist.html#forex_exchange_bcm',
            '/gridlist.html#forex_exchange_cmb',
        ]
    },
    {
        page: react_1.default.createElement(future_1.PageFuture, null),
        path: [
            '/futures.html'
        ]
    },
    {
        page: react_1.default.createElement(qihuo_grid_1.PageQiHuoGrid, null),
        path: [
            '/gridlist.html#futures_energy',
            '/gridlist.html#futures_finance',
            '/gridlist.html#futures_metal',
            '/gridlist.html#futures_farmproduce',
            '/gridlist.html#futures_113',
            '/gridlist.html#futures_142',
            '/gridlist.html#futures_114',
            '/gridlist.html#futures_115',
            '/gridlist.html#futures_225',
            // 期货-中金所
            '/gridlist.html#futures_cffex',
            '/gridlist.html#futures_cffex-_ts',
            '/gridlist.html#futures_cffex-_tf',
            '/gridlist.html#futures_cffex-_t',
            '/gridlist.html#futures_cffex-_tl',
            '/gridlist.html#futures_cffex-_ih',
            '/gridlist.html#futures_cffex-_ic',
            '/gridlist.html#futures_cffex-_if',
            '/gridlist.html#futures_cffex-_im',
            // 期货-港交所
            // '/gjs.html#futures_hkex',   // futures_hkex港交所有延时市场处理
            // '/gridlist.html#hk_index_futures',
            // '/gridlist.html#hk_stock_futures',
            // '/gridlist.html#hcf_cus',
            // '/gridlist.html#hmfs_lrp',
            // 期货-国际期货
            '/gridlist.html#futures_global',
            '/gridlist.html#futures_global-cobot',
            '/gridlist.html#futures_global-nymex',
            '/gridlist.html#futures_global-comex',
            '/gridlist.html#futures_global-nybot',
            '/gridlist.html#futures_global-lme',
            '/gridlist.html#futures_global-ipe',
            '/gridlist.html#futures_global-tocom',
            '/gridlist.html#futures_global-sgx',
            '/gridlist.html#futures_global-mdex',
        ]
    },
    {
        page: react_1.default.createElement(futures_1.PageFutureChilds, null),
        path: [
            '/gridlist.html#futures_{d}_{d}', // 期货单品种通用
        ]
    },
    {
        page: react_1.default.createElement(qqsc_1.PageQQSC, null),
        path: [
            '/qqsc.html'
        ]
    },
    {
        page: react_1.default.createElement(option_sh_sz_1.PageOptionA, null),
        path: [
            '/gridlist.html#options_sh50etf_all',
            '/gridlist.html#options_sh50etf_call',
            '/gridlist.html#options_sh50etf_put',
            '/gridlist.html#options_szetf_all',
            '/gridlist.html#options_sz50etf_all',
            '/gridlist.html#options_sz50etf_rengou',
            '/gridlist.html#options_sz50etf_rengu',
            '/gridlist.html#options_kc50etf_all',
            '/gridlist.html#options_sahs300etf_all',
            '/gridlist.html#options_sahs300etf_rengou',
            '/gridlist.html#options_sahs300etf_rengu',
            '/gridlist.html#options_sazz500etf_all',
            '/gridlist.html#options_sazz500etf_rengou',
            '/gridlist.html#options_sazz500etf_rengu',
            '/gridlist.html#options_kc50etf1_all',
            '/gridlist.html#options_kc50etf1_rengou',
            '/gridlist.html#options_kc50etf1_rengu',
            '/gridlist.html#options_kc50etf2_all',
            '/gridlist.html#options_kc50etf2_rengou',
            '/gridlist.html#options_kc50etf2_rengu',
            '/gridlist.html#options_sehs300etf_all',
            '/gridlist.html#options_sehs300etf_rengou',
            '/gridlist.html#options_sehs300etf_rengu',
            '/gridlist.html#options_sezz500etf_all',
            '/gridlist.html#options_sezz500etf_rengou',
            '/gridlist.html#options_sezz500etf_rengu',
            '/gridlist.html#options_secybetf_all',
            '/gridlist.html#options_secybetf_rengou',
            '/gridlist.html#options_secybetf_rengu'
        ]
    },
    {
        page: react_1.default.createElement(option_qihuo_1.PageOptionQiHuo, null),
        path: [
            '/gridlist.html#options_cffex_all',
            '/gridlist.html#options_shfe_all',
            '/gridlist.html#options_dce_all',
            '/gridlist.html#options_czce_all',
            '/gridlist.html#options_ine_all',
            '/gridlist.html#options_gfex_all',
            '/gridlist.html#options_zjcffex_all',
            '/gridlist.html#options_zjcffex_rengou',
            '/gridlist.html#options_zjcffex_rengu',
            '/gridlist.html#options_zjcffex_mo_all',
            '/gridlist.html#options_zjcffex_mo_rengou',
            '/gridlist.html#options_zjcffex_mo_rengu',
            '/gridlist.html#options_zjcffex_ho_all',
            '/gridlist.html#options_zjcffex_ho_rengou',
            '/gridlist.html#options_zjcffex_ho_rengu',
            // 期权-上期所
            '/gridlist.html#options_cu_all',
            '/gridlist.html#options_ru_all',
            '/gridlist.html#options_au_all',
            '/gridlist.html#options_al_all',
            '/gridlist.html#options_zn_all',
            '/gridlist.html#options_rb_all',
            '/gridlist.html#options_ag_all',
            '/gridlist.html#options_br_all',
            '/gridlist.html#options_pb_all',
            '/gridlist.html#options_ni_all',
            '/gridlist.html#options_sn_all',
            '/gridlist.html#options_ao_all',
            '/gridlist.html#options_beanpulp_all',
            '/gridlist.html#options_c_all',
            // 期权-大商所
            '/gridlist.html#options_t_all',
            '/gridlist.html#options_lpg_all',
            '/gridlist.html#options_pp_all',
            '/gridlist.html#options_pvc_all',
            '/gridlist.html#options_pe_all',
            '/gridlist.html#options_p_all',
            '/gridlist.html#options_a_all',
            '/gridlist.html#options_b_all',
            '/gridlist.html#options_y_all',
            '/gridlist.html#options_eg_all',
            '/gridlist.html#options_eb_all',
            '/gridlist.html#options_jd_all',
            '/gridlist.html#options_cs_all',
            '/gridlist.html#options_lh_all',
            '/gridlist.html#options_lg_all',
            // 期权-郑商所
            '/gridlist.html#options_sugar_all',
            '/gridlist.html#options_cf_all',
            '/gridlist.html#options_cf_ta',
            '/gridlist.html#options_cf_ma',
            '/gridlist.html#options_cf_cp',
            '/gridlist.html#options_cf_oi',
            '/gridlist.html#options_cf_pk',
            '/gridlist.html#options_cf_px',
            '/gridlist.html#options_cf_sh',
            '/gridlist.html#options_cf_sf',
            '/gridlist.html#options_cf_sm',
            '/gridlist.html#options_cf_ap',
            '/gridlist.html#options_cf_ur',
            '/gridlist.html#options_cf_sa',
            '/gridlist.html#options_cf_pf',
            '/gridlist.html#options_cf_fg',
            '/gridlist.html#options_cf_cj',
            // 期权-上期能源
            '/gridlist.html#options_ine_sc',
            // 期权-广期所
            '/gridlist.html#options_gfex_si',
            '/gridlist.html#options_gfex_lc',
            '/gridlist.html#options_gfex_ps',
            // 期权-港期所
            '/gridlist.html#options_uscny_all',
        ]
    },
    {
        page: react_1.default.createElement(option_qihuo_1.PageOptionQiHuo, null),
        path: [
            '/gridlist.html#options_{market}_{type}',
        ]
    },
    {
        page: react_1.default.createElement(option_txbj_1.PageOptionTXBJ, null),
        path: [
            '/gridlist.html#options_sz50etf_txbj',
            '/gridlist.html#options_sahs300etf_txbj',
            '/gridlist.html#options_sazz500etf_txbj',
            '/gridlist.html#options_kc50etf1_txbj',
            '/gridlist.html#options_kc50etf2_txbj',
            '/gridlist.html#options_sehs300etf_txbj',
            '/gridlist.html#options_sezz500etf_txbj',
            '/gridlist.html#options_secybetf_txbj',
            '/gridlist.html#options_zjcffex_txbj',
            '/gridlist.html#options_zjcffex_mo_txbj',
            '/gridlist.html#options_zjcffex_ho_txbj'
        ]
    }
];
